import { useSelector } from 'react-redux'
import { useMemo } from 'react'

export function useAuthorMap() {
  const users = useSelector((state) => state.userModule.users)
  return useMemo(() => {
    const map = {}
    users.forEach((user) => {
      map[user._id] = user
    })
    return map
  }, [users])
}
